import Index from './index.vue'
import BlankLayout from '../layout/blankLayout.vue'

const basePath = '/v-admin/edit-company-profile'

export default {
  name: 'editCompanyProfileRoute',
  path: basePath,
  redirect: basePath,
  component: BlankLayout,
  meta: {
    isInclude: true,
    titleI18nKey: 'admin.layout.header.userMenu.editCompanyProfile'
  },
  children: [
    {
      path: basePath,
      component: Index,
      meta: {
        titleI18nKey: 'admin.layout.header.userMenu.editCompanyProfile'
      }
    }
  ]
}
